import { useDispatch, useSelector } from "react-redux";

import HTTP_REQUEST from "@/utils/http";
import url from "@/utils/url";
import { decryptCredentials } from "../utils/cifrate";
import helpers from "../utils/helpers";
import { PLANS_FINISH, PLANS_START, PLANS_SUCCESS } from "@/redux/types/plans";
import { changeGlobalState } from "@/redux/actions/global";
import { adaptEndorseQuoteVEData } from "@/adapters/quote.adapters";
import { ADD_THIRD_SUCCESS } from "@/redux/types/plans";
import { savePlanId, setMaxAmountQuote } from "@/redux/actions/plans";
import {
  formatAmountThousand,
  formatToSelect,
  deleteDuplicateObject,
} from "@/utils/Utils";
import { CODE_VIDA_CT } from '@/utils/consts'
import { setSuscriptionEnabled } from '@/redux/actions/vida'

export const useQuoteService = () => {
  const dispatch = useDispatch();
  const plans = useSelector((state) => state.plans);
  const { beneficiaries } = useSelector((state) => state.beneficiaries);

  const getAttribute = async (params, type) => {
    const headers = {
      "x-api-key": decryptCredentials(process.env.REACT_APP_API_KEY_VIDA_CT),
    };
    try {
      const response = await HTTP_REQUEST.getWithHeaders(
        "CANAL_VIDA_CT",
        url.obtenerAtributoValorVe,
        { headers, queryStringParameters: params }
      );
      const { payload } = response;
      if (payload) {
        let attributeFormated;
        switch (type) {
          case "sumAssured":
            let itemsSumAssured = payload.reglas;
            const maxAMountValue = Number(payload.filtroMontoMaximo?.valor);
            dispatch(setMaxAmountQuote(maxAMountValue));
            attributeFormated = formatToSelect(itemsSumAssured, {
              value: "valor",
              text: "valor",
            });
            attributeFormated.map((item, index) => {
              if (index === attributeFormated.length - 1) {
                item.text = "Monto más alto";
              } else {
                item.text = `${item.descripcion}${formatAmountThousand(item.text)}`;
              }
              return item;
            });
            break;
          case "savingTime":
            let itemsSavingTime = payload.reglas;
            attributeFormated = formatToSelect(itemsSavingTime, {
              value: "valor",
              text: "valor",
            });
            attributeFormated.map((item) => (item.text = `${item.text}`));
            break;
          case "returnPercentage":
            let itemsReturnPercentage = payload.reglas;
            attributeFormated = formatToSelect(itemsReturnPercentage, {
              value: "valor",
              text: "valor",
            });
            attributeFormated.sort((a, b) => Number(a.text) - Number(b.text));
            attributeFormated.map((item) => (item.text = `${item.text}%`));
            break;
          case "suscription":
            const validation = payload?.reglas?.[0]?.dscValor;
            const shouldRedirectToSuscription = validation === 'true';
            return shouldRedirectToSuscription;
          default:
            break;
        }
        return deleteDuplicateObject(attributeFormated, "text");
      } else {
        dispatch(changeGlobalState(4));
      }
    } catch (error) {
      helpers.sendTagError(error, url.obtenerAtributoValorVe);
      dispatch(changeGlobalState(4));
    }
  };

  const getSuscriptionValidation = async params => {
    const shouldRedirectToSuscription = await getAttribute(
			{
				...params,
				codigoAplicacion: CODE_VIDA_CT.APPLICATION,
				codigoProducto: CODE_VIDA_CT.PRODUCT,
				atributo: 'Suscripcion',
			},
			'suscription'
		)
    dispatch(setSuscriptionEnabled(shouldRedirectToSuscription))
  }

  const createQuoteVe = async (params) => {
    const bodyRequest = helpers.getBodySimple(params);
    bodyRequest.headers = {
      "x-api-key": decryptCredentials(process.env.REACT_APP_API_KEY_VIDA_CT),
    };
    dispatch({ type: PLANS_START });
    try {
      const response = await HTTP_REQUEST.AmplifyApi({
        name: "CANAL_VIDA_CT",
        path: url.quoteVe,
        data: bodyRequest,
      });
      const { payload } = response;
      if (payload?.idCotizacion) {
        dispatch({
          type: PLANS_SUCCESS,
          data: payload,
        });
      } else {
        dispatch(changeGlobalState(4));
      }
      return payload;
    } catch (error) {
      const currentError =
        error?.response?.data?.error ||
        error?.response?.data?.response?.status?.error;
      helpers.sendTagError(error, url.obtenerPlanes);
      if (currentError?.code) {
        helpers.getTagError(
          currentError?.code,
          "Problema técnico cotización",
          "trackError"
        );
      }
    } finally {
      dispatch({
        type: PLANS_FINISH,
      });
    }
  };

  const selectQuoteVe = async (params) => {
    const bodyRequest = helpers.getBodySimple(params);
    bodyRequest.headers = {
      "x-api-key": decryptCredentials(process.env.REACT_APP_API_KEY_VIDA_CT),
    };
    try {
      const response = await HTTP_REQUEST.AmplifyApi({
        name: "CANAL_VIDA_CT",
        path: `${url.quoteVe}/${plans.planSelected.idCotizacion}`,
        data: bodyRequest,
        method: "put",
      });
      const { payload } = response;
      if (payload?.idCotizacion) {
        dispatch(savePlanId(payload.planId));
        return payload;
      } else {
        dispatch(changeGlobalState(4));
      }
    } catch (error) {
      dispatch(changeGlobalState(4));
      helpers.sendTagError(
        error,
        `${url.quoteVe}/${plans.planSelected.idCotizacion}`
      );
    }
  };

  const endorseQuoteVE = async ({ userData, domicilioData }) => {
    const data = adaptEndorseQuoteVEData({
      userData,
      domicilioData,
      plans,
      beneficiaries
    });
    const bodyRequest = helpers.getBodySimple(data);
    bodyRequest.headers = {
      "x-api-key": decryptCredentials(process.env.REACT_APP_API_KEY_VIDA_CT),
    };

    try {
      await HTTP_REQUEST.AmplifyApi({
        name: "CANAL_VIDA_CT",
        path: url.endorseQuoteVE,
        data: bodyRequest,
      });
      
      dispatch({ type: ADD_THIRD_SUCCESS });
    } catch (error) {
      dispatch(changeGlobalState(4));
      helpers.sendTagError(error, url.endorseQuoteVE);
    }
  };

  return {
    getAttribute,
    createQuoteVe,
    endorseQuoteVE,
    selectQuoteVe,
    getSuscriptionValidation,
  };
};
